import React from "react";
import { Box, Card, Text } from "@mantine/core";
import type { IComment } from "@backend/src/shared/schemas/schemas";
import { useAppSelector } from "../../app/hooks";
import { CommentsSection } from "../../components/comments/CommentsSection";
import { selectHttpSingleRoomFull } from "../../Room/httpRoomSelectors";
import { selectHttpCurrentUser } from "../../userSelectors";
import {
  usePostMultiplacerRoomCeilingCommentDeleteMutation,
  usePostMultiplacerRoomCeilingCommentMutation,
  usePostMultiplacerRoomCeilingCommentUpdateMutation,
} from "../../../openapi";

export const CeilingCommentsPanel: React.FC = () => {
  const projectNo = useAppSelector((state) => state.design.projectNo);
  const room = useAppSelector(selectHttpSingleRoomFull);
  const currentUser = useAppSelector(selectHttpCurrentUser);

  const [addComment, { isLoading: isAdding }] = usePostMultiplacerRoomCeilingCommentMutation();
  const [updateComment, { isLoading: isUpdating }] =
    usePostMultiplacerRoomCeilingCommentUpdateMutation();
  const [deleteComment, { isLoading: isDeleting }] =
    usePostMultiplacerRoomCeilingCommentDeleteMutation();

  const comments = (room?.ceilingComments ?? []) as IComment[];
  const canSave = projectNo != null && room?.roomNumber != null;
  const isSubmitting = isAdding || isUpdating || isDeleting;

  if (!room) {
    return (
      <Box p="md">
        <Text size="sm" c="dimmed">
          Velg et rom for å se kommentarer.
        </Text>
      </Box>
    );
  }

  return (
    <Card withBorder radius="md" h="100%" p="md" style={{ overflow: "auto" }}>
      <CommentsSection
        title="Kommentarer"
        comments={comments}
        currentUserId={currentUser?._id ? String(currentUser._id) : undefined}
        isSubmitting={isSubmitting}
        onCreateComment={async (message) => {
          if (!canSave) return;
          await addComment({
            body: {
              projectNo,
              roomNumber: room.roomNumber,
              message,
            },
          });
        }}
        onEditComment={async (commentId, newMessage) => {
          if (!canSave) return;
          await updateComment({
            body: {
              projectNo,
              roomNumber: room.roomNumber,
              commentId,
              message: newMessage,
            },
          });
        }}
        onDeleteComment={async (commentId) => {
          if (!canSave) return;
          await deleteComment({
            body: {
              projectNo,
              roomNumber: room.roomNumber,
              commentId,
            },
          });
        }}
      />
    </Card>
  );
};
